/**
 * A detail screen can name its record (a contact's name, an invoice number) so the
 * breadcrumb and the browser tab say "Ada Lovelace" instead of "Contact":
 *
 *   useRecordName(contact?.name);
 *
 * Kept apart from the shell components so a screen importing it pulls in nothing else.
 */
import { createContext, useContext, useEffect } from 'react';

export const RecordNameContext = createContext<(name: string | null) => void>(() => undefined);

export function useRecordName(name: string | null | undefined): void {
  const setName = useContext(RecordNameContext);
  useEffect(() => {
    setName(name?.trim() ? name.trim() : null);
    return () => setName(null);
  }, [name, setName]);
}
